module.exports = __webpack_public_path__ + "static/7-4ac69b28dc2ab4334d89c86cdd7ff111.jpg";